import types from 'redux/types';
import { setDefaultFilter, changeFilter } from 'redux/stateCase';

const changeFilterNotification = (filters) => {
  return {
    type: changeFilter(types.CHANGE_FILTER_NOTIFICATION),
    filterNotification: {
      ...filters,
    },
  };
};

// Filter Creative
const changeFilterCreative = (filters, resetForm) => {
  return {
    type: changeFilter(types.CHANGE_FILTER_CREATIVE),
    filterCreative: {
      ...filters,
    },
    resetForm,
  };
};

const setFilterCreativeDefault = () => {
  return {
    type: setDefaultFilter(types.CHANGE_FILTER_CREATIVE),
  };
};

// Filter Campaign
const changeFilterCampaign = (filters) => {
  return {
    type: changeFilter(types.CHANGE_FILTER_CAMPAIGN),
    filterCampaign: {
      ...filters,
    },
  };
};

const setFilterCampaignDefault = () => {
  return {
    type: setDefaultFilter(types.CHANGE_FILTER_CAMPAIGN),
  };
};

// Offers
const changeFilterOffers = (filters, resetForm) => {
  return {
    type: changeFilter(types.CHANGE_FILTER_OFFERS),
    filterOffers: {
      ...filters,
    },
    resetForm,
  };
};

const setFilterDefaultOffers = () => {
  return {
    type: setDefaultFilter(types.CHANGE_FILTER_OFFERS),
  };
};

export default {
  changeFilterNotification,
  setFilterDefaultOffers,
  setFilterCampaignDefault,
  setFilterCreativeDefault,
  changeFilterCreative,
  changeFilterOffers,
  changeFilterCampaign,
};
